export default {
    // 查询操作级别
    queryOperationLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/queryOperationLevel', params, response);
    },
    // 删除操作级别
    deleteOperationLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/deleteOperationLevel', params, response);
    },
    // 添加操作级别
    addOperationLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/saveOperationLevel', params, response);
    },
    // 更新操作级别
    updateOperationLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/updateOperationLevel', params, response);
    },
    // 查询所有操作级别
    getAllOperationLevel(params, response) {
        window.vue.$apiAxios.get('/auth/operationType/getAllOperationLevel', params, response);
    },
    // 批量删除操作级别
    deleteOperationLevelBatch(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/deleteOperationLevelBatch', params, response);
    },
    // 查询操作类型重复
    checkOperationLevel(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/operationType/checkOperationLevel', params, response);
    },
    // 获取所有系统
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    }
};
